//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data() {
        return {
            rotate: false,
            currentValue:'',
        }
    },
    props: {
        options: {
            type: Array,
            default: ()=>{
                return []
            }
        },
        value:[String,Number,Object]
    },
    created () {
        this.currentValue = this.options[0].value
    },
    methods: {
        
        btnClick() {
            this.$refs.input.focus()
        },
        current(item){
            this.currentValue = item.value
            this.$emit('input', item.value)
            this.$refs.input.blur()
        },
        blur(){
            if(this.rotate ){
                this.$nextTick(()=>{
                    this.rotate = false
                })
            }   
            
        }
    },
}
